<template>
  <div class="crypto-literacy bg--color-01">
    <div class="container-wrapper bg--color-08">
      <div class="crypto-literacy__container container-new">
        <div class="crypto-literacy__image-with-info">
          <img
            class="crypto-literacy__image"
            width="100%"
            src="@/assets/img/crypto-campus/crypto-literacy/book.svg"
            alt="book image"
          >
          <div class="crypto-literacy__info">
            <h4
              class="txt--bold txt--36px txt--44px--l txt--height-44px txt--height-58px--l txt--color-04 mb-24"
            >
              {{ $t('cryptoCampus.cryptoLiteracy.title') }}
            </h4>
            <p
              class="txt--weight-400 txt--16px txt--22px--l txt--height-20px txt--height-30px--l txt--color-03 mb-24"
            >
              {{ $t('cryptoCampus.cryptoLiteracy.desc') }}
            </p>
            <exc-button class="crypto-literacy__btn" size="l" color="dark" href="https://campus.patex.io/category/courses/Crypto-Literacy" target="__blank">
              {{ $t('cryptoCampus.topSection.learnNow') }}
            </exc-button>
          </div>
        </div>
        <div class="crypto-literacy__items">
          <div
            v-for="(item, indx) in items"
            :key="items[item]"
            class="crypto-literacy__item"
            :class="`crypto-literacy__item--${indx}`"
          >
            <img
              class="crypto-literacy__item-level mb-12"
              width="100%"
              :src="
                require(`@/assets/img/crypto-campus/crypto-literacy/levels/${indx}.svg`)
              "
              alt="level icon"
            >
            <span
              class="txt--bold txt--22px  txt--height-30px txt--color-04 mb-12"
            >
              {{ item.title }}
            </span>
            <p
              class="txt--weight-400 txt--16px txt--height-20px txt--color-04 mb-12 mb-32--l"
            >
              {{ item.desc }}
            </p>
            <div class="crypto-literacy__item-access">
              <span
                class="txt--weight-400 txt--16px txt--height-20px txt--color-05"
                v-html="item.access"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ExcButton } from '@/components/common'

export default {
  name: 'CryptoLiteracy',
  components: {
    ExcButton,
  },
  computed: {
    items () {
      return [
        {
          title: this.$t('cryptoCampus.cryptoLiteracy.levels.0.title'),
          desc: this.$t('cryptoCampus.cryptoLiteracy.levels.0.desc'),
          access: this.$t('cryptoCampus.cryptoLiteracy.levels.0.access'),
        },
        {
          title: this.$t('cryptoCampus.cryptoLiteracy.levels.1.title'),
          desc: this.$t('cryptoCampus.cryptoLiteracy.levels.1.desc'),
          access: this.$t('cryptoCampus.cryptoLiteracy.levels.1.access'),
        },
        {
          title: this.$t('cryptoCampus.cryptoLiteracy.levels.2.title'),
          desc: this.$t('cryptoCampus.cryptoLiteracy.levels.2.desc'),
          access: this.$t('cryptoCampus.cryptoLiteracy.levels.2.access'),
        },
        {
          title: this.$t('cryptoCampus.careerGuidance.levels[0].title'),
          desc: this.$t('cryptoCampus.careerGuidance.levels[0].desc'),
          access: this.$t('cryptoCampus.careerGuidance.levels[0].access'),
        },
      ]
    },
  },
}
</script>

<style lang="scss" scoped>
.crypto-literacy {
  &__container {
    display: flex;
    flex-direction: column;
    gap: toRem(24px);

    @include bp(l) {
      gap: toRem(60px);
    }
  }

  &__image-with-info {
    display: grid;
    gap: toRem(24px);

    @include bp(m) {
      grid-template-columns: repeat(2, 1fr);
    }

    @include bp(l) {
      gap: toRem(52px);
    }
  }

  &__image {
    @include bp(0, m) {
      max-width: toRem(346px);
    }
  }

  &__info {
    margin: auto 0;
  }

  &__btn {
    max-width: fit-content;
  }

  &__items {
    display: grid;
    gap: toRem(16px);

    @include bp(m) {
      grid-template-columns: repeat(2, 1fr);
    }

    @include bp(l) {
      gap: toRem(24px);
    }
  }

  &__item {
    border-radius: toRem(16px);
    padding: toRem(16px);
    border: 1px solid color('color-04');
    background: color('color-01');
    display: flex;
    flex-direction: column;
    position: relative;

    @include bp(l) {
      &::after {
        content: url('@/assets/img/crypto-campus/crypto-literacy/star.svg');
        position: absolute;
      }

      &--0 {
        &::after {
          top: toRem(-30px);
          left: toRem(296px);
        }
      }

      &--1 {
        &::after {
          display: none;
        }
      }

      &--2 {
        &::after {
          bottom: toRem(-36px);
          left: toRem(346px);
        }
      }

      &--3 {
        &::after {
          top: toRem(-30px);
          right: toRem(36px);
        }
      }
    }
  }

  &__item-level {
    max-width: toRem(50px);
  }

  &__item-access {
    margin-top: auto;
    border-radius: toRem(10px);
    padding: toRem(12px);
    background: color('transp-04');
  }
}
</style>
